import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Header from './Header';
import Footer from './Footer';
import { useCompanyInfo } from '../hooks/useAPI';

const NotFoundPage = () => {
  const { data: companyInfo } = useCompanyInfo();

  return (
    <div className="min-h-screen bg-gray-50">
      <Helmet>
        <title>Page Not Found | LionTek</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <Header companyInfo={companyInfo} />

      <main className="pt-24 pb-20">
        <div className="container mx-auto px-6 max-w-2xl text-center">
          <h1 className="text-8xl font-poppins font-bold text-lion-blue mb-4">404</h1>
          <h2 className="text-2xl font-poppins font-semibold text-gray-700 mb-4">
            Page Not Found
          </h2>
          <p className="text-gray-500 mb-8">
            Sorry, the page you're looking for doesn't exist or has been moved.
          </p>
          <Link
            to="/"
            className="inline-block bg-lion-blue text-white px-8 py-3 rounded-full font-semibold hover:bg-blue-800 transition-colors duration-300"
          >
            ← Back to Home
          </Link>
        </div>
      </main>

      <Footer companyInfo={companyInfo} />
    </div>
  );
};

export default NotFoundPage;
